export default "__VITE_ASSET__B9j_spzw__"